import {useAppSelector} from '@/hooks';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {useEffect, useState} from 'react';
import {POSTER_MIN_DURATION} from '@PosterWhiteboard/poster/poster.types';

export function useGetPosterMinDuration(): number {
  const currentPageObject = useAppSelector(getCurrentPage);
  const [minDuration, setMinDuration] = useState(POSTER_MIN_DURATION);

  useEffect(() => {
    const duration = window.posterEditor?.whiteboard?.getCurrentPage().items.getMaxAnimationTime();
    if (duration && duration !== minDuration) {
      setMinDuration(duration);
    }
  }, [currentPageObject]);

  return minDuration;
}
